// Small deterministic formatters used across pages.

export function formatTime(seconds: number | null | undefined): string {
  if (seconds == null || Number.isNaN(seconds)) return "–";
  const s = Math.max(0, Math.round(seconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, "0")}`;
}

export function formatTemp(
  value: number | null | undefined,
  unit: "C" | "F" | null | undefined,
): string {
  if (value == null || Number.isNaN(value)) return "–";
  const u = unit ?? "C";
  return `${Math.round(value * 10) / 10}°${u}`;
}

export function formatNumber(value: number | null | undefined, digits = 1): string {
  if (value == null || Number.isNaN(value)) return "–";
  return value.toFixed(digits);
}

export function formatPercent(value: number | null | undefined, digits = 1): string {
  if (value == null || Number.isNaN(value)) return "–";
  return `${(value * 100).toFixed(digits)}%`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "–";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString();
}

export function formatConfidence(
  confidence: number | null | undefined,
): { label: string; cls: "ok" | "warn" | "err" | "" } {
  if (confidence == null) return { label: "–", cls: "" };
  const pct = Math.round(confidence * 100);
  const cls = confidence >= 0.75 ? "ok" : confidence >= 0.5 ? "warn" : "err";
  return { label: `${pct}%`, cls };
}
